import PropTypes from 'prop-types';

const LOADING_ERROR_PROP_TYPES = PropTypes.shape({
  message: PropTypes.string,
  statusCode: PropTypes.number,
});

export default LOADING_ERROR_PROP_TYPES;
